import { render } from "./TopbarSection.vue?vue&type=template&id=3ae2f0c1&scoped=true"
import script from "./TopbarSection.vue?vue&type=script&lang=js"
export * from "./TopbarSection.vue?vue&type=script&lang=js"

import "./TopbarSection.vue?vue&type=style&index=0&id=3ae2f0c1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae2f0c1"]])

export default __exports__